export function isNearEnd(element, percent = 80) {
  const body = document.body;

  const scrollTop = element.scrollTop || body.scrollTop;
  const scrollHeight = element.scrollHeight || body.scrollHeight;
  const totalHeight = element.clientHeight || body.clientHeight;

  const scrollPercent = ((scrollTop / (scrollHeight - totalHeight)) * 100);

  return scrollPercent >= percent;
}
